/*#__NO_SIDE_EFFECTS__*/
var noop = function noop(any) {
  return any;
};
export { noop };